import React from 'react';
import useEventListner from '../../useEventListner';
import { PageContext } from '../..';
import VendexAction from '../../../models/VendexAction';
import { VendexTextMeta } from '../../../models/VendexElement';

type Props = {
  id: string;
  actions?: VendexAction[];
  data: VendexTextMeta;
};

const VendexText: React.FC<Props> = ({ id, data, actions }) => {
  const [text, setText] = React.useState<string>('');
  const ref = React.useRef<HTMLParagraphElement>(null);
  const { value = '', type = 'STATIC' } = data;
  useEventListner(ref, actions);
  const {store} = React.useContext(PageContext);

  React.useEffect(() => {
    if (type === 'DYNAMIC' && value.length > 0) {
      setText(store.data[data.value] ?? '');
    }
    if (type === 'STATIC') {
      setText(data.value);
    }
    if (type === 'SYSTEM_MESSAGE') {
      setText(window.MESSAGE && window.MESSAGE.length > 0 ? window.MESSAGE : value);
    }
  }, [store.data]);

  return (
    <p id={id} ref={ref} data-vendex>
      {text}
    </p>
  );
};
export default VendexText;
